// Admin routes for P5-A (PRODUCT, MEDIA, SEARCH). Owned by that worker; the router mounts whatever this returns under the
// app shell (before the store-area placeholder), so modules never edit router.tsx. Paths follow IA §2.1 and the nav
// tree in shell/nav.ts (products, products/categories, products/collections, products/brands, media). Pages are
// code-split (lazyRouteComponent), so the catalog screens never weigh on the shell's first load.
import { createRoute, lazyRouteComponent, type AnyRoute } from "@tanstack/react-router";

const products = () => import("../products/ProductsPage");
const taxonomy = () => import("../products/Taxonomy");
const media = () => import("../media/MediaLibrary");

export function catalogRoutes(appRoute: AnyRoute): AnyRoute[] {
  // Pages may take optional props (ProductsPage `adding`); the router passes none, so any lazy page fits.
  const r = (path: string, component: unknown) =>
    createRoute({
      getParentRoute: () => appRoute,
      path,
      component: component as ReturnType<typeof lazyRouteComponent>,
    }) as unknown as AnyRoute;
  return [
    r("/$org/$store/products", lazyRouteComponent(products, "ProductsPage")),
    r("/$org/$store/products/new", lazyRouteComponent(products, "ProductsNewPage")),
    r("/$org/$store/products/categories", lazyRouteComponent(taxonomy, "CategoriesPage")),
    r("/$org/$store/products/collections", lazyRouteComponent(taxonomy, "CollectionsPage")),
    r("/$org/$store/products/brands", lazyRouteComponent(taxonomy, "BrandsPage")),
    // The list with the product's edit popup (owner, 2026-10-27), not the old full-page editor.
    r("/$org/$store/products/$productId", lazyRouteComponent(products, "ProductsEditPage")),
    r("/$org/$store/media", lazyRouteComponent(media, "MediaLibraryPage")),
  ];
}
